import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { Controller } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';

export default function BaseSelect({
	control,
	name,
	label,
	errors,
	data,
	config = { styles: {}, classes: '', disabled: false, optionLabel: '', keyVal: 'value', keyName: 'name', keyLabel: 'name' },
	options,
	...props
}) {
	//* otherSetting should be put on CONFIG props as ONE object ex: styles
	const { styles, classes, disabled, optionLabel, keyVal = 'value', keyName = 'name', keyLabel = 'name', isRequired = false } = config;
	const errText = `${name} is required `;
	const isError = errors?.name || errors[name];
	const errMsg = errors.name?.message || errors[name]?.message;
	return (
		<FormControl sx={styles} className={['w-full', classes].join(' ')} variant='outlined' size={props.size || 'small'}>
			{label && <InputLabel id={name}>{label}</InputLabel>}
			<Controller
				control={control}
				name={name}
				render={({ field: { onChange, value, ref } }) => {
					return (
						<>
							<Select
								labelId={name}
								disabled={disabled}
								name={name}
								label={label}
								options={options}
								value={value || ''}
								ref={ref}
								onChange={(e) => {
									onChange(e);
								}}
								error={!!isError}
								placeholder={optionLabel || ''}
								className={twMerge('bg-white border', isError ? '' : '')}
								{...props}
							>
								{!isRequired && (
									<MenuItem value=''>
										<em className='text-gray-300'>{optionLabel}</em>
									</MenuItem>
								)}
								{data?.map((p) => (
									<MenuItem key={p[keyVal || 'id']} value={p[keyVal]} name={p[keyName]}>
										{p[keyLabel]}
									</MenuItem>
								))}
							</Select>
							{isError && <FormHelperText className='!text-red-600'>{errMsg ? errMsg : errText}</FormHelperText>}
						</>
					);
				}}
			/>
		</FormControl>
	);
}
